<template>
  <cTable
    :fields="fields"
    :header="header"
    :methods="methods"
    :modals="modals"
    :footer="footer"
    :config="config"
    ref="table"
  >
  </cTable>
</template>

<script>
import { getCodBankFee, getCodBankFeeDetail, Delete } from "@/api/finance/cod_bank_fee";
import { getAllClient, getCompanies } from "@/api/user/client";
import cTable from "@/base/common/index";
export default {
  name: "cod_bank_fee",
  components: {
    cTable,
  },
  async mounted() {
    // let companiesList = (await getCompanies()).data.payload;
    // let client = (await getAllClient()).data.payload.rows;
    // this.header.searchs.forEach(item => {
    //   if (item.key === "ownership") item.options = companiesList;
    //   if (item.key === "client_id") item.options = client;
    // });
  },
  data() {
    let that = this;
    return {
      generate: null,
      config: {
        children: true,
      },
      methods: {
        list: getCodBankFee,
        getCodBankFeeDetail,
				Delete
      },
      modals: {
        showDetails: {
          config: {
            listFn: "getCodBankFeeDetail",
            modalBind: {
              width: 1200,
            },
            rowBind: {
              gutter: 16,
              style: {
                marginBottom: "20px",
              },
            },
          },
          footer: {
            show: false,
          },
          fields: [],
          table: {
            config: {
              align: "center",
              height: 600,
            },
            footer: {
              show: false,
            },
            fields: [
              {
                name: () => this.$t("order_number"),
                key: "airway_number",
                align: "center",
                tooltip: true,
                minWidth: 100,
              },
              {
                name: () => this.$t("ownership"),
                key: "ownership",
                align: "center",
                tooltip: true,
                minWidth: 100,
              },
              {
                name: () => this.$t("codAmount"),
                key: "cod_amount",
                align: "center",
                tooltip: true,
                minWidth: 100,
              },
              {
                name: () => this.$t("cod_currency"),
                key: "cod_currency",
                align: "center",
                tooltip: true,
                minWidth: 100,
              },
              {
                name: () => this.$t("to") + this.$t("rate"),
                key: "to_rate",
                align: "center",
                tooltip: true,
                minWidth: 100,
              },
              {
                name: () => this.$t("target_country"),
                key: "to_country",
                align: "center",
                tooltip: true,
                minWidth: 100,
              },
              {
                name: () => this.$t("to") + this.$t("reChAmount"),
                key: "to_amount",
                align: "center",
                tooltip: true,
                minWidth: 100,
              },
              {
                name: () => this.$t("to") + this.$t("currency_t"),
                key: "to_currency",
                align: "center",
                tooltip: true,
                minWidth: 100,
              },
              {
                name: () => this.$t("HandlingFee") + this.$t("ratio"),
                key: "fee_ratio",
                align: "center",
                tooltip: true,
                minWidth: 100,
              },
              {
                name: () => this.$t("HandlingFee"),
                key: "fee",
                align: "center",
                tooltip: true,
                minWidth: 100,
              },
              {
                name: () => this.$t("createTime"),
                key: "create_time",
                align: "center",
                tooltip: true,
                minWidth: 100,
              },
            ],
          },
        },
      },
      footer: { show: () => true },
      header: {
        searchs: [
          // {
          //   key: "client_id",
          //   placeholder() {
          //     return this.$t("select") + this.$t("clientName");
          //   },
          //   component: "Select",
          //   options: [],
          //   config: {
          //     label: "account",
          //     value: "id"
          //   }
          // },
          // {
          //   key: "ownership",
          //   placeholder() {
          //     return this.$t("select") + this.$t("ownership");
          //   },
          //   component: "Select",
          //   options: [],
          //   config: {
          //     label: "title",
          //     value: "id"
          //   }
          // },
          {
            key: "keywords",
            placeholder() {
              return this.$t("keyword");
            },
            component: "Input",
            bind: {
              type: "textarea",
              autosize: { minRows: 1, maxRows: 1 },
            },
          },
        ],
        btns: {
          list: [
            {
              name: () => this.$t("export"),
              type: "export",
              fnName: "export",
              disabled() {
                return !this.selectAll.length;
              },
              bind: {
                icon: "md-arrow-down",
                type: "primary",
              },
            },
						{
							name: this.$t("delete"),
							type: "delete",
							fnName: "delete",
							bind: {
								icon: "md-trash",
								type: "error",
							},
							disabled() {
								return (
									!this.selectAll.length 
								);
							},
						},
          ],
          methods: {
            export() {
              this.exportExc();
            },
						delete() {
							this.$Modal.confirm({
								title: this.$t("whether") + this.$t("delete"),
								width: 300,
								content: this.$t("titleModal"),
								onOk: () => {
									let data = {
										ids: this.selectAll.map((item) => {
											return item.id;
										}),
									};
									this.handleRequestMethods("Delete", data).then(
										(res) => {
											this.$Message["success"]({
												background: true,
												content: res.msg,
											});
											this.getList();
										}
									);
								},
							});
						},
          },
        },
      },
      fields: [
        {
          type: "checkbox",
          width: 60,
          fixed: "left",
        },
        {
          name: () => this.$t("bill_number"),
          key: "bill_number",
          width: 220,
          copy: true,
          fixed: "left",
          component: "Button",
          bind: {
            type: "primary",
            size: "small",
          },
          methods: {
            async click({ row }) {
              this.$page
                .getModal("showDetails")
                .setTitle(this.$t("bill_number") + row.bill_number);
              this.$page.getModal("showDetails").open({ row }, function () {
                let data = {
                  id: row.id,
                };
                this.pageConfig.data = data;
                this.getList(data);
              });
            },
          },
        },
        {
          name: () => this.$t("bill_name"),
          key: "bill_name",
          minWidth: 100,
        },
        {
          name: () => this.$t("clientName"),
          key: "client_name",
          minWidth: 100,
        },
        {
          name: () => this.$t("ownership"),
          key: "ownership",
          minWidth: 100,
        },
        {
          name: () => this.$t("cod_number"),
          key: "cod_num",
          minWidth: 100,
        },
        {
          name: () => this.$t("exlType"),
          key: "status_txt",
          width: 80,
        },
        {
          name: () => this.$t("to") + this.$t("currency_t"),
          key: "to_currency",
          width: 80,
        },
        {
          name: () => this.$t("HandlingFee") + this.$t("ratio"),
          key: "fee_ratio",
          width: 80,
        },
        {
          name: () => this.$t("codAmount"),
          key: "cod_amount",
          width: 100,
        },
        {
          name: () => this.$t("fee_type"),
          key: "cod_fee",
          width: 100,
        },
        {
          name: () => this.$t("operate"),
          key: "operator_name",
          width: 100,
        },
        {
          name: () => this.$t("createTime"),
          key: "create_time",
          width: 130,
        },
      ],
    };
  },
};
</script>
